// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form:has(> .lsn-busy-cover),
div:has(> .lsn-busy-cover),
button:has(> .lsn-busy-cover) {
  position: relative;
  z-index: 1;
}
form:has(> .lsn-busy-cover) > *:not(.lsn-busy-cover),
div:has(> .lsn-busy-cover) > *:not(.lsn-busy-cover),
button:has(> .lsn-busy-cover) > *:not(.lsn-busy-cover) {
  opacity: 0.5;
  filter: blur(3px);
}
.lsn-busy-cover {
  position: absolute;
  top: -0.1rem;
  right: -0.1rem;
  bottom: -0.1rem;
  left: -0.1rem;
  container: busycover / size;
}
.lsn-busy-cover svg {
  z-index: 2;
  position: absolute;
  left: calc(50% - 30px);
  top: min(20vh, 20cqh);
}
.lsn-busy-cover .spinner {
  transform-origin: center;
  -webkit-animation: animation-spin 1.5s infinite linear;
  animation: animation-spin 1.5s infinite linear;
  -webkit-filter: drop-shadow(1px 1px 2px var(--main-primary-color));
  filter: drop-shadow(1px 1px 2px var(--main-primary-color));
  fill: var(--main-primary-color);
}
.lsn-busy-cover.has-error path {
  fill: var(--main-red);
}
.lsn-busy-cover.has-error .spinner {
  -webkit-filter: drop-shadow(1px 1px 2px var(--main-red));
  filter: drop-shadow(1px 1px 2px var(--main-red));
}
@-webkit-keyframes animation-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes animation-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/BusyCover/BusyCover.less"],"names":[],"mappings":"AAAA;;;EAGE,kBAAA;EACA,UAAA;AACF;AALA;;;EAOI,YAAA;EACA,iBAAA;AAGJ;AACA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;AACF;AAPA;EASI,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;AACJ;AAbA;EAgBI,wBAAA;EACA,sDAAA;EACA,8CAAA;EACA,kEAAA;EACA,0DAAA;EACA,+BAAA;AAAJ;AAGE;EAEI,qBAAA;AAFN;AAAE;EAMI,wDAAA;EACA,gDAAA;AAHN;AAOE;EACE;IACE,+BAAA;IACA,uBAAA;EALJ;EAQE;IACE,iCAAA;IACA,yBAAA;EANJ;AACF;AASE;EACE;IACE,+BAAA;IACA,uBAAA;EAPJ;EAUE;IACE,iCAAA;IACA,yBAAA;EARJ;AACF","sourcesContent":["form:has(> .lsn-busy-cover),\ndiv:has(> .lsn-busy-cover),\nbutton:has(> .lsn-busy-cover) {\n  position: relative;\n  z-index: 1;\n\n  >*:not(.lsn-busy-cover) {\n    opacity: .5;\n    filter: blur(3px);\n  }\n}\n\n.lsn-busy-cover {\n  position: absolute;\n  top: -.1rem;\n  right: -.1rem;\n  bottom: -.1rem;\n  left: -.1rem;\n  container: busycover / size;\n\n  svg {\n    z-index: 2;\n    position: absolute;\n    left: calc(50% - 30px);\n    top: min(20vh, 20cqh);\n  }\n\n  .spinner {\n    transform-origin: center;\n    -webkit-animation: animation-spin 1.5s infinite linear;\n    animation: animation-spin 1.5s infinite linear;\n    -webkit-filter: drop-shadow(1px 1px 2px var(--main-primary-color));\n    filter: drop-shadow(1px 1px 2px var(--main-primary-color));\n    fill: var(--main-primary-color);\n  }\n\n  &.has-error {\n    path {\n      fill: var(--main-red);\n    }\n\n    .spinner {\n      -webkit-filter: drop-shadow(1px 1px 2px var(--main-red));\n      filter: drop-shadow(1px 1px 2px var(--main-red));\n    }\n  }\n\n  @-webkit-keyframes animation-spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes animation-spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
